import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Card, Form, Input, message, Radio } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useParams, useLocation } from "react-router";
import { useEffect } from "react";
import { testimonyLaboratoryService } from "../../../services/testimony-laboratory.service";
import CardFooterAction from "../../../components/CardFooterAction";

export default function TestimonyLaboratoryForm(){
  const { id } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const location = useLocation();
  const { TextArea } = Input;

  // Initialize the form with default values or data from location state
  useEffect(() => {
    if (!id) {
      // If creating new, set default values
      form.setFieldsValue({
        isActive: true
      });
    } else {
      // If editing, get the data passed from the index component via location state
      const testimonyData = location.state?.testimony;
      if (testimonyData) {
        form.setFieldsValue(testimonyData);
      }
    }
  }, [form, id, location.state]);

  const storeMutation = useMutation({
    mutationFn: (data) => testimonyLaboratoryService.store(data),
    onSuccess: () => {
      queryClient.invalidateQueries('testimonyLaboratory');
      message.success('Data berhasil disimpan');
      form.resetFields();
      navigate('/lab-service/testimony');
    },
    onError: (error) => {
      console.log(error);
      message.error('Terjadi Kesalahan');
    }
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, formData }) => testimonyLaboratoryService.update(id, formData),
    onSuccess: () => {
      queryClient.invalidateQueries('testimonyLaboratory');
      message.success('Data berhasil diubah');
      form.resetFields();
      navigate('/lab-service/testimony');
    },
    onError: (error) => {
      console.log(error);
      message.error('Terjadi Kesalahan');
    }
  });
  
  const isPending = storeMutation.isPending || updateMutation.isPending;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, formData: values });
    }
  };

  return (
    <>
      <Card
        title={ (id ? "Ubah" : "Tambah") + " Testimoni Laboratorium"}
        actions={[
          <CardFooterAction
            key={'1'}
            route={'/lab-service/testimony'}
            onClick={() => form.submit()}
            loading={isPending}
          />
        ]}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          <Form.Item hidden name={'id'} >
            <Input/>
          </Form.Item>
          
          <Form.Item
            name={'origin'}
            label="Asal"
            rules={[
              {
                required: true,
                message: 'Asal tidak boleh kosong'
              }
            ]}
          >
            <Input placeholder="Contoh: Makassar, Jakarta, dll"/>
          </Form.Item>

          <Form.Item
            name={'name'}
            label="Nama"
            rules={[
              {
                required: true,
                message: 'Nama tidak boleh kosong'
              }
            ]}
          >
            <Input placeholder="Nama pemberi testimoni"/>
          </Form.Item>
          
          <Form.Item
            name={'content'}
            label="Testimoni"
            rules={[
              {
                required: true,
                message: 'Testimoni tidak boleh kosong'
              }
            ]}
          >
            <TextArea
              placeholder="Isi testimoni"
              autoSize={{ minRows: 4, maxRows: 8 }}
              maxLength={500}
              showCount
            />
          </Form.Item>
          
          <Form.Item
            name={'isActive'}
            label="Status"
            rules={[
              {
                required: true,
                message: 'Status tidak boleh kosong'
              }
            ]}
          >
            <Radio.Group>
              <Radio style={{ marginRight: 80}} value={true}>Aktif</Radio>
              <Radio value={false}>Nonaktif</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
}